import { InvoiceItemType } from '../models/api-models';

// Invoice item type mappings (not related to taxes)
export const ITEM_TYPE_DISPLAY_NAMES: Record<number, string> = {
    [InvoiceItemType.P]: 'Produto',
    [InvoiceItemType.S]: 'Serviço',
    [InvoiceItemType.O]: 'Outro (portes, adiantamentos, etc.)',
    [InvoiceItemType.I]: 'Imposto (excepto IVA e IS) ou Encargo Parafiscal',
    [InvoiceItemType.E]: 'Imposto Especial de Consumo (IABA, ISP e IT)',
};

export const ITEM_TYPE_OPTIONS = [
    ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.P],
    ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.S],
    ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.O],
    ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.I],
    ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.E],
];

export const ITEM_TYPE_MAP: Record<string, InvoiceItemType> = {
    [ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.P]]: InvoiceItemType.P,
    [ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.S]]: InvoiceItemType.S,
    [ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.O]]: InvoiceItemType.O,
    [ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.I]]: InvoiceItemType.I,
    [ITEM_TYPE_DISPLAY_NAMES[InvoiceItemType.E]]: InvoiceItemType.E,
};

/**
 * Builds a map of tax exemption codes to display text.
 * Uses data from API exclusively - no hardcoded fallbacks.
 */
export const buildTaxExemptionOptionsMap = (taxExemptions: Array<{ id: string; text: string }>): Record<string, string> => {
    const map: Record<string, string> = {};
    taxExemptions.forEach(exemption => {
        if (exemption && exemption.id && exemption.text) {
            map[exemption.id] = exemption.text;
        }
    });
    return map;
};
